import { computed } from "vue";
import { useDisplay } from "vuetify";

export default function useAccessibility() {
  const display = useDisplay();

  return {
    resolveXSmallComponentSize: computed(() => {
      return display.mdAndUp.value ? "x-small" : "default";
    }),
    resolveSmallComponentSize: computed(() => {
      return display.mdAndUp.value ? "small" : "default";
    }),
  };
}
